import * as z from "zod";

export const InternationalCustomsFlatTeamSettingsSchema = z.object({
  "customsAugmentation/artifactId": z.string().nullish(),
  "customsAugmentation/metafieldKeys/product": z.array(z.string()).nullish(),
  "customsAugmentation/metafieldKeys/variant": z.array(z.string()).nullish(),
});
